import axios from "axios";
import { formatApiError } from "@/utils/formatters";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export { formatApiError };
export default api;
